module.exports = __webpack_public_path__ + "img/title1.b239e518.png";